import * as actions from './actions';

export default function(state = [], action) {
  switch (action.type) {

  case actions.ADD_DEFAULT_REMINDER:
    return [
      ...state,
      action.reminder,
    ];

  case actions.DELETE_DEFAULT_REMINDER:
    return state.filter(reminder => reminder.id !== action.reminder.id);

  default:
    return state;
  }
}
